import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { AktePopup } from "./AktePopup";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { VersandService } from "../../Services/VersandService";



@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent
  ],
  selector: 'ExportPopup',
  templateUrl: './ExportPopup.html',
  standalone: true,
  styleUrl: './ExportPopup.css'
})
export class ExportPopup implements OnChanges, AfterViewInit {

  toastService: ToastService;

  private modalService = inject(NgbModal);
  modal = inject(NgbActiveModal);
  Entrys = signal<any[]>([])
  selected: number[] = [];
  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)

  }
  async ngAfterViewInit() {
    this.Entrys.set(await this.Client.Get<any>('/Backend/Api/V2/Status/Versand/Kooperationspartner'))
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  addOrRemoveID(key: number) {
    var entry = this.selected.find(o => o == key);

    if (entry) {
      this.selected = this.selected.filter(o => o != key)
    }
    else {
      this.selected.push(key);
    }
  }

  async Export() {
    await this.VersandService.DownloadMultiPart('/Backend/Api/V2/VersandAuftraege/MassSendByKooperationsPartner/File', this.selected);
    this.modal.dismiss();
  }

  VersandService : VersandService = inject(VersandService);



  Client: RestClient = new RestClient();




}
